import React from "react";

import { useActionHook } from "hooks";
import { useDealActions } from "store";
import { Characteristic } from "store/types";

import { Form } from "./Form";

interface Props {
  onSuccess: (characteristic: Characteristic) => void;
  onCancel: () => void;
  data: Characteristic | null;
}

export const Update: React.FC<Props> = ({ onSuccess, data, onCancel }) => {
  const { updateCharacteristicAction } = useDealActions();

  const { loading, action } = useActionHook(updateCharacteristicAction, {
    onSuccess
  });

  return (
    <Form
      {...(data && { onSubmit: (values) => action({ id: data.id, ...values }) })}
      onCancel={onCancel}
      isLoading={loading}
      initialState={data}
    />
  );
};
